import type { ListItem } from './api'

/** The natures a typed term finds, codes first.
 *
 *  ONE DEFINITION FOR THE TWO BOXES THAT ASK: the intake picker and the filter
 *  on Settings -> Nature of call. The customer: the code is used "to find
 *  faster the nature of call and the search box" -- so typing FT has to put
 *  Flat tire at the top of both, and two copies of the ranking would be two
 *  answers to which nature a dispatcher meant.
 *
 *  THREE RANKS, in this order: the code IS the term, the code starts with it,
 *  the name contains it. The middle rank is what keeps the list steady while
 *  somebody types F on the way to FT. Inside a rank the order is the one the
 *  list arrived in, which is the server's `sort_order, name`; nothing here
 *  sorts, so there is no second ordering to disagree with it.
 *
 *  Codes are stored in capitals, so the term is compared in capitals too.
 */
export function findNatures<T extends ListItem>(
  natures: readonly T[], term: string,
): T[] {
  const typed = term.trim()
  if (!typed) return [...natures]
  const upper = typed.toUpperCase()
  const lower = typed.toLowerCase()
  const ranked: T[][] = [[], [], []]
  for (const nature of natures) {
    const code = nature.code ?? ''
    if (code === upper) ranked[0].push(nature)
    else if (code.startsWith(upper)) ranked[1].push(nature)
    else if (nature.name.toLowerCase().includes(lower)) ranked[2].push(nature)
  }
  return ranked.flat()
}
